import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LOCALE, LOCALE_LIST, DEFAULT_LOCALE } from '@link/portal/utils';
import enPortalText from './lang/en';
import jaPortalText from './lang/ja';
import koPortalText from './lang/ko';
import zhPortalText from './lang/zh';
import ztPortalText from './lang/zt';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  [LOCALE.EN]: {
    translation: {
      ...enPortalText
    }
  },
  [LOCALE.JA]: {
    translation: {
      ...jaPortalText
    }
  },
  [LOCALE.KO]: {
    translation: {
      ...koPortalText
    }
  },
  [LOCALE.ZH]: {
    translation: {
      ...zhPortalText
    }
  },
  [LOCALE.ZT]: {
    translation: {
      ...ztPortalText
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  returnNull: false,
  interpolation: {
    escapeValue: false
  },
  resources
});

export function setLocale(locale: LOCALE): LOCALE {
  void i18n.changeLanguage(locale);
  document.documentElement.setAttribute('lang', locale.toLowerCase());
  localStorage.setItem('locale', locale);
  return locale;
}

function getLocaleParams() {
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get('lang')?.toLowerCase() || '';
  if (LOCALE_LIST.includes(lang as LOCALE)) {
    return lang;
  }
}

(() => {
  const defaultLocale =
    getLocaleParams() || localStorage.getItem('locale') || DEFAULT_LOCALE;
  setLocale(defaultLocale as LOCALE);
})();

export default i18n;
